import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    linkList: {
      display: "flex",
      flexDirection: "column",
      marginLeft: 11,
    },
    menuItem: {
      margin: [16, 0],
      display: "block",
      "&#ecards, & #button-invitations, &#ai-image-packs": {
        color: theme.palette.primary.main,
      },
    },
    activelink: {
      "&::after": {
        content: "''",
        display: "block",
        background: theme.palette.primary.main,
        width: "4px",
        height: "24px",
        position: "absolute",
        marginTop: "-24px",
        marginLeft: "-10px",
      },
    },
    linkInList: {
      margin: [13, 0],
    },
  }),
  { name: "MenuItem" },
);
